import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=2d3038f4&scoped=true&"
import script from "./calculator.vue?vue&type=script&lang=ts&"
export * from "./calculator.vue?vue&type=script&lang=ts&"
import style0 from "./calculator.vue?vue&type=style&index=0&id=2d3038f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3038f4",
  null
  
)

export default component.exports